export default "__VITE_ASSET__CTyAtBDW__"